import axios from '../util/api';
import { validateEmail } from '../util/email';

class UserAPI {
  static login (user, password) {
    let param = user;
    try {
      param = validateEmail(user) ? user.toLowerCase() : user;
    } catch (error) { /* */ }
    return axios.post('/login', { email: param, password });
  }
  static registerInterest (cowId, cowName, phone, email, message) {
    const params = { cowId, cowName };
    if (phone) params.phone = phone;
    if (email) params.email = email;
    if (message) params.message = message;
    return axios.post(
      '/user/register-interest',
      params
    );
  }
  static sendFeedback (message, email = false) {
    const params = { message };
    if (email) params.email = email;
    return axios.post(
      '/users/send-feedback',
      params
    );
  }
  static requestCallback (name, email, phone, message) {
    const website = window.location.hostname;
    return axios.post(
      '/users/request-callback',
      { name, email, phone, message, website }
    );
  }
  static sendMessage (name, email, message) {
    const website = window.location.hostname;
    return axios.post(
      '/users/send-message',
      { name, email, message, website }
    );
  }
}

export default UserAPI;
